import JSBI from 'jsbi';
import { BigintIsh } from '@uniswap/sdk-core';

export const toJSBI = (value: bigint): JSBI => JSBI.BigInt(value.toString());
export const toBigintish = (value: bigint): BigintIsh => toJSBI(value);
export const toBigint = (value: JSBI): bigint => BigInt(value.toString());
export const abs = (n: bigint): bigint => (n < 0n ? -n : n);

// Convert slippage percentage to string for input manipulation
export function convertPercentageBigIntToString(value: bigint) {
  return (Number(value) / 100).toString();
}

// Convert slippage percent back to bigint for storage
export function convertPercentageStringToBigInt(value: string) {
  return BigInt((parseFloat(value) * 100).toFixed(0));
}
